import { FnsCheckStatusesEnum } from '../enums/FnsCheckStatusesEnum';

export interface IFnsCheckMessageByStatus {
  fnsCheckMessage: string;
  statuses: FnsCheckStatusesEnum[];
  type: FnsCheckStatusesEnum;
}

export const fnsCheckMessageByStatuses: IFnsCheckMessageByStatus[] = [
  {
    fnsCheckMessage:
      'ИНН не найден в базе данных ЕРКНМ. Сохраните КНМ/ПМ и ожидайте загрузки информации из ФНС России, время  ожидания составляет до 2 часов.',
    statuses: [FnsCheckStatusesEnum.IN_PROGRESS, FnsCheckStatusesEnum.NOT_FOUND],
    type: FnsCheckStatusesEnum.IN_PROGRESS,
  },
  {
    fnsCheckMessage: 'Информация успешно получена из ФНС России. Проверьте правильность данных о контролируемом лице.',
    statuses: [FnsCheckStatusesEnum.FOUND, FnsCheckStatusesEnum.NOT_FOUND],
    type: FnsCheckStatusesEnum.FOUND,
  },
  {
    fnsCheckMessage: 'Информации об ИНН в ФНС России не найдено, введите действительный ИНН.',
    statuses: [FnsCheckStatusesEnum.NOT_FOUND, FnsCheckStatusesEnum.NOT_FOUND],
    type: FnsCheckStatusesEnum.NOT_FOUND,
  },
  {
    fnsCheckMessage:
      'Выписка не может быть предоставлена в текущий момент. Необходимо обратиться в службу технической поддержки.',
    statuses: [FnsCheckStatusesEnum.NO_DATA_56, FnsCheckStatusesEnum.NOT_FOUND],
    type: FnsCheckStatusesEnum.NO_DATA_56,
  },
  {
    fnsCheckMessage: 'Сверка данных о контролируемом лице с ФНС не выполнена.',
    statuses: [FnsCheckStatusesEnum.NO_DATA_53, FnsCheckStatusesEnum.NOT_FOUND],
    type: FnsCheckStatusesEnum.NO_DATA_53,
  },
  {
    fnsCheckMessage: 'Данные не соответствуют информации из ФНС России, внесите изменение в ЕРВК',
    statuses: [FnsCheckStatusesEnum.DATA_NOT_EQUALS_ERVK, FnsCheckStatusesEnum.DATA_NOT_EQUALS_ERVK],
    type: FnsCheckStatusesEnum.DATA_NOT_EQUALS_ERVK,
  },
];
